export default "__VITE_ASSET__2hyHHPWD__"